import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Leaf } from "lucide-react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function Navbar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const links = [
    { to: "/", label: t("nav.home"), key: "home" },
    { to: "/chi-sono", label: t("nav.about"), key: "about" },
    { to: "/servizi", label: t("nav.services"), key: "services" },
    { to: "/blog", label: t("nav.blog"), key: "blog" },
    { to: "/testimonianze", label: t("nav.testimonials"), key: "testimonials" },
    { to: "/contatti", label: t("nav.contact"), key: "contact" },
  ];

  return (
    <header className="glass-nav fixed top-0 inset-x-0 z-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
          onClick={() => setOpen(false)}
        >
          <Leaf className="w-5 h-5 text-[#8A9A86] group-hover:rotate-12 transition-transform" strokeWidth={1.5} />
          <div className="leading-tight">
            <div className="font-serif text-lg sm:text-xl text-[#2C2F2A]">Valeria Cantore</div>
            <div className="label-eyebrow text-[10px]">{t("tagline")}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.key}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  isActive ? "text-[#8A9A86]" : "text-[#2C2F2A] hover:text-[#8A9A86]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <button
            data-testid="nav-cta-book"
            onClick={() => nav("/prenotazioni")}
            className="hidden lg:inline-flex btn-primary text-sm"
          >
            {t("nav.book")}
          </button>

          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-[#2C2F2A]"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E6E2D8]/70 bg-[#FDFBF7]" data-testid="nav-mobile-menu">
          <div className="px-5 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.key}`}
                className={({ isActive }) =>
                  `text-base ${isActive ? "text-[#8A9A86]" : "text-[#2C2F2A]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <button
              data-testid="mobile-cta-book"
              onClick={() => { setOpen(false); nav("/prenotazioni"); }}
              className="btn-primary mt-2 w-full"
            >
              {t("nav.bookAppointment")}
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
